import {FormControl, Flex, Text, Input} from 'native-base';
import React from 'react';

export const renderFormField = ({
  label,
  onChangeText,
  isOptional = false,
  isInvalid = false,
  errorMessage,
  value = '',
  onBlur,
  maxLength,
}: {
  label: string;
  onChangeText: (text: string) => void;
  isInvalid?: boolean;
  isOptional?: boolean;
  errorMessage?: string;
  value: string;
  onBlur?: () => void;
  maxLength?: number;
}) => (
  <FormControl isInvalid={isInvalid}>
    <Flex direction="row" justifyItems={'end'}>
      <FormControl.Label
        _text={{
          fontSize: '11px',
          fontWeight: 'bold',
          fontFamily: 'Arial',
          textTransform: 'uppercase',
          color: '#343840',
        }}>
        {label}
      </FormControl.Label>
      {isOptional ? (
        <Text ml={'16px'} fontStyle={'italic'} fontSize={'11px'} mt="4px">
          Optional
        </Text>
      ) : null}
    </Flex>
    <Input
      _focus={{
        borderBottomWidth: '3px',
        borderBottomRadius: '0',
        borderColor: '#707784',
      }}
      _hover={{borderColor: '#707784'}}
      fontSize="16px"
      fontWeight="600"
      px="12px"
      py="6px"
      mb="8px"
      mt="2px"
      placeholder={label}
      value={value}
      onChangeText={onChangeText}
      onBlur={onBlur}
      placeholderTextColor="#707378"
      variant="unstyled"
      borderWidth="1px"
      color="#707784"
      h="44px"
      maxLength={maxLength}
    />
    <FormControl.ErrorMessage
      _text={{
        color: '#dc3545',
        fontSize: '13px',
        fontFamily: 'Arial',
      }}>
      {errorMessage}
    </FormControl.ErrorMessage>
  </FormControl>
);
